<div class='flex flex-col mt-6 gap-4' data-cy='power-profile-section'>
  <h1 class='text-xl font-medium mb-2'>Power Profile</h1>

  <mat-form-field class='w-full'>
    <mat-label data-cy='power-profile-select-label'>Select Power Profile</mat-label>
    <mat-select data-cy='power-profile-select'
                [value]='selectedProfileId()'
                (valueChange)='selectedProfileId.set($event)'>
      @for (profile of availableProfiles(); track profile.id) {
        <mat-option [value]='profile.id' [attr.data-cy]="'power-profile-option-' + profile.id">
          {{ profile.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class='flex flex-row gap-2 w-full'>
    <button data-cy='power-profile-create-button'
            mat-raised-button color='accent'
            class='flex-1 !min-w-0 !px-2 whitespace-nowrap'
            (click)='openCreateDialog()'>
      <span class='or-icon or-small or-inverse or-icon-plus'></span>
      <span class='or-button-label text-base'>Create</span>
    </button>
    <button data-cy='power-profile-edit-button'
            mat-raised-button
            class='flex-1 !min-w-0 !px-2 whitespace-nowrap'
            [disabled]='!canEdit()'
            (click)='openEditDialog()'>
      <span class='or-icon or-small or-icon-edit'></span>
      <span class='or-button-label text-base'>Edit</span>
    </button>
    <button data-cy='power-profile-assign-button'
            mat-raised-button color='primary'
            class='flex-1 !min-w-0 !px-2 whitespace-nowrap'
            [disabled]='!canAssign()'
            (click)='assign()'>
      <span class='or-icon or-small or-inverse or-icon-checkmark'></span>
      <span class='or-button-label text-base'>Assign</span>
    </button>
  </div>
</div>
